import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    desktopContainer: {
      '@media (max-width: 1180px)': {
        display: 'none',
      },
    },
    filters: {
      flexGrow: 0,
      maxWidth: '45%',
      flexBasis: '45%',
    },
    mobileContainer: {
      '@media (min-width: 1181px)': {
        display: 'none',
      },
    },
    option: {
      '& span': {
        marginInlineStart: 20,
      },
      '& svg path': {
        stroke: variables.black10,
      },
    },
    selectedOption: {
      '& svg path': {
        stroke: variables.richBlack,
      },
      '& span': {
        marginInlineStart: 20,
      },
    },
    dialog: {
      width: 343,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
    },
    placeholder: {
      color: '#030C2133',
    },
    partnership: {
      width: '100%',
      fontSize: 12,
      color: `${variables.richBlack} !important;`,
      height: 40,
      fontWeight: 700,
    },
    currency: {
      width: '100%',
      height: 40,
      fontSize: 12,
      fontWeight: 700,
      color: `${variables.richBlack} !important;`,
    },
    country: {
      width: '100%',
      height: 40,
      fontSize: 12,
      fontWeight: 700,
      color: `${variables.richBlack} !important;`,
    },
    selectedGroup: {
      width: '100%',
      borderRadius: '8px !important;',
      backgroundColor: `${variables.white} !important;`,
      textTransform: 'none',
      color: `${variables.richBlack} !important;`,
    },
    groupByContainer: {
      height: 48,
      backgroundColor: `${variables.black10} !important;`,
      borderRadius: '8px !important;',
      boxShadow: 'none !important;',
      color: `${variables.richBlack} !important;`,
      padding: 4,
    },
  }),
);
